import { createContext } from 'react';

import type { ToastProps } from './useToast';

/** Undefined where no `ToastProvider` is mounted, which is what `useToast` falls back from. */
const ToastContext = createContext<ToastProps | undefined>(undefined);

export default ToastContext;
